import { createReducer, on } from '@ngrx/store';
import { LanguageActions } from './language.actions';
import { LanguageState, initialLanguageState } from './models/language-state.models';

export const languageReducer = createReducer(
  initialLanguageState,

  // Initialize
  on(LanguageActions.initialize, (state): LanguageState => ({
    ...state,
    loading: true,
    error: null
  })),
  on(LanguageActions.initializeSuccess, (state, { language }): LanguageState => ({
    ...state,
    activeLanguage: language,
    loading: false,
    error: null
  })),
  on(LanguageActions.initializeFailure, (state, { error }): LanguageState => ({
    ...state,
    loading: false,
    error
  })),

  // Set active language
  on(LanguageActions.setActiveLanguage, (state): LanguageState => ({
    ...state,
    loading: true,
    error: null
  })),
  on(LanguageActions.setActiveLanguageSuccess, (state, { language }): LanguageState => ({
    ...state,
    activeLanguage: language,
    loading: false,
    error: null
  })),
  on(LanguageActions.setActiveLanguageFailure, (state, { error }): LanguageState => ({
    ...state,
    loading: false,
    error
  })),

  // Update user preferred language
  on(LanguageActions.updateUserPreferredLanguage, (state): LanguageState => ({
    ...state,
    loading: true,
    error: null
  })),
  on(LanguageActions.updateUserPreferredLanguageSuccess, (state, { language }): LanguageState => ({
    ...state,
    activeLanguage: language,
    loading: false,
    error: null
  })),
  on(LanguageActions.updateUserPreferredLanguageFailure, (state, { error }): LanguageState => ({
    ...state,
    loading: false,
    error
  })),

  // Load user preferred language
  on(LanguageActions.loadUserPreferredLanguage, (state): LanguageState => ({
    ...state,
    loading: true,
    error: null
  })),
  on(LanguageActions.loadUserPreferredLanguageSuccess, (state, { language }): LanguageState => ({
    ...state,
    activeLanguage: language !== null ? language : state.activeLanguage,
    loading: false,
    error: null
  })),
  on(LanguageActions.loadUserPreferredLanguageFailure, (state, { error }): LanguageState => ({
    ...state,
    loading: false,
    error
  })),

  // Language changed from backend via websocket
  on(LanguageActions.languageChangedFromBackend, (state, { language }): LanguageState => ({
    ...state,
    activeLanguage: language,
    error: null
  })),

  // Reset language (on logout)
  on(LanguageActions.resetLanguage, (): LanguageState => ({
    ...initialLanguageState
  }))
);
